import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, IconButton } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import { PATH } from 'routes/path';
import { mainHeaderHeight } from 'theme/constants';
import logo from 'assets/images/main_logo.png';
import { useActions } from 'store';
import { storeDrawerOpen } from 'store/appSettings/actions';
import { UserResponseViewModel } from 'types/user';
import isNull from 'lodash/isNull';
import { AppBar } from './Appbar';
import { MyProfile } from './MyProfile';

const toolbarStyles = {
    minHeight: mainHeaderHeight,
};

const iconButtonStyles = {
    mr: 2,
};

const logoStyles = {
    height: '50px',
    '&:hover': {
        cursor: 'pointer',
    },
};

interface Props {
    open: boolean;
    user: UserResponseViewModel | null;
}

export const Header = ({ open, user }: Props) => {
    const actions = useActions({ storeDrawerOpen });
    const navigate = useNavigate();

    const goToLoginHandler = useCallback(() => {
        navigate(PATH.LOGIN);
    }, []);

    const goToHomeHandler = useCallback(() => {
        navigate(PATH.ROOT);
    }, []);

    const handleDrawerOpen = useCallback(() => {
        actions.storeDrawerOpen(true);
    }, [actions]);

    return (
        <AppBar position="fixed" open={open} user={user}>
            <Toolbar variant="dense" sx={toolbarStyles}>
                <Box display="flex" alignItems="center">
                    {user && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            sx={iconButtonStyles}
                        >
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Box sx={logoStyles} onClick={goToHomeHandler}>
                        <img src={logo} alt="contaldi lit it" height={50} />
                    </Box>
                </Box>
                {isNull(user) ? (
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ marginLeft: 'auto' }}
                        onClick={goToLoginHandler}
                    >
                        Log In
                    </Button>
                ) : (
                    <MyProfile avatar={user?.profilePicture?.filePath || ''} sx={{ marginLeft: 'auto' }} />
                )}
            </Toolbar>
        </AppBar>
    );
};
